/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaRecordData model module.
 * @module model/AqaRecordData
 * @version v0
 */
export default class AqaRecordData {
  /**
   * Constructs a new <code>AqaRecordData</code>.
   * @alias module:model/AqaRecordData
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaRecordData</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaRecordData} obj Optional instance to populate.
   * @return {module:model/AqaRecordData} The populated <code>AqaRecordData</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaRecordData();
      if (data.hasOwnProperty('data'))
        obj.data = ApiClient.convertToType(data['data'], 'String');
      if (data.hasOwnProperty('bulk'))
        obj.bulk = ApiClient.convertToType(data['bulk'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} data
 */
AqaRecordData.prototype.data = undefined;

/**
 * @member {String} bulk
 */
AqaRecordData.prototype.bulk = undefined;

